import naja from 'naja';
import {Naja} from 'Naja';

interface CustomWindow extends Window {
  naja?: Naja;
}

declare const window: CustomWindow;

export default function (): Naja {
    naja.initialize();

    if (window.naja === undefined || window.naja === null) {
        window.naja = naja;
    }

    return window.naja;
}
